import { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Container, Button } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Profile1 from "../assets/profile1.png";
import Logo1 from "../assets/frame.png";

const testimonials = [
  {
    text: "“Finally, a tool that understands small businesses.” Managing multiple business accounts used to be chaos. Now it’s all streamlined under one account — clean, intuitive, and stress-free.",
    name: "Aisha Patel",
    title: "Boutique Owner",
    image: Profile1,
    companyLogo: Logo1,
  },
  {
    text: "“WriteOffGenie is a lifesaver during tax season.” I used to spend hours organizing receipts. Now it’s stress-free, and I actually enjoy checking my finances!",
    name: "Raj Mehta",
    title: "Freelancer",
    image: Profile1,
    companyLogo: Logo1,
  },
  {
    text: "“The AI categorization is pure genius.” I used to miss so many deductions — now I don’t have to think about it at all.",
    name: "Elena Thomas",
    title: "Realtor",
    image: Profile1,
    companyLogo: Logo1,
  },
];

const TestimonySection = () => {
  const [cardsToShow, setCardsToShow] = useState(3);
  const containerRef = useRef(null);

  // const [scrollX, setScrollX] = useState(0);
  console.log(cardsToShow)

  const handleResize = () => {
    const width = window.innerWidth;
    if (width < 480) setCardsToShow(1);
    else if (width < 768) setCardsToShow(1);
    else if (width < 992) setCardsToShow(2);
    else setCardsToShow(3);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const scrollLeft = () => {
  //   if (containerRef.current) {
  //     containerRef.current.scrollBy({ left: -370, behavior: "smooth" });
  //   }
  // };

  // const scrollRight = () => {
  //   if (containerRef.current) {
  //     containerRef.current.scrollBy({ left: 370, behavior: "smooth" });
  //   }
  // };

  const scroll = (direction) => {
    if (containerRef.current) {
      const card = containerRef.current.querySelector(".carousel-card");
      const cardWidth = card ? card.offsetWidth : 300; // fallback in case not found
      const scrollAmount = direction === "left" ? -cardWidth - 60 : cardWidth + 60; // add some gap

      containerRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="testimony-section py-5">
      <Container>
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="fw-bold display-6 text-dark">
            Trusted by business owners like you.
          </h2>
          <p className="text-secondary fs-5 mt-2">
            From freelancers to startups — WriteOffGenie helps everyone save more.
          </p>
        </motion.div>

        <div className="carousel-wrapper position-relative">
          <div className="carousel-container" ref={containerRef}>
            {testimonials.map((t, index) => (
              <motion.div
                className="carousel-card"
                key={index}
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <p className="fs-6">{t.text}</p>
                <div className="card-bottom d-flex justify-content-between align-items-center">
                  <div className="profile d-flex align-items-center gap-3">
                    <img src={t.image} alt={t.name} width={60} height={60} />
                    <div>
                      <h6 className="mb-0">{t.name}</h6>
                      <small className="text-secondary">{t.title}</small>
                    </div>
                  </div>
                  <div className="logo">
                    <img
                      src={t.companyLogo}
                      alt="Company Logo"
                      style={{ width: "120px", height: "auto" }}
                    />
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="carousel-nav d-flex justify-content-center mt-4 gap-3">
            <Button className="rounded-circle" onClick={() => scroll("left")} >
              <FaArrowLeft />
            </Button>
            <Button className="rounded-circle" onClick={() => scroll("right")} >
              <FaArrowRight />
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default TestimonySection;
